module.exports = __webpack_public_path__ + "static/img/14075A_1_C_20200811_LC.6395960.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/14075A_1_C_20200811_LC.png
// module id = /Ysk
// module chunks = 0